// @flow
import React, { useState, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as sessionActionCreators from "../../action-creators/session-actions";
import * as modalActionCreators from "../../action-creators/modal-actions";
import "./styles.css";
import Email from "../../components/email";
import Password from "../../components/password";
import Spinner from "../../components/spinner";
import logo from "../../assets/green-up-logo.png";


type PropsType = {
    actions: { [string]: any => void },
    error: string
};

const MyScreen = ({ actions, error }: PropsType): React$Element<any> => {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoggingIn, setIsLoggingIn] = useState(false);

    return (
        <Fragment>
            <div className={ `login--loading${ isLoggingIn ? " is-visible" : "" }` }>
                <Spinner message={ "Logging In" }/>
            </div>
            <div className="login">
                <img
                    alt="logo"
                    className="login--logo"
                    src={ logo }
                />
                <form className={ "login--form" }
                      onSubmit={ (e) => {
                          e.preventDefault();
                          return false;
                      } }>
                    <Email autoComplete={ "email" }
                           className={ "login--email" }
                           errorMessage={ "Invalid Email" }
                           labelText={ "email" }
                           onChange={ setEmail }
                           value={ email }/>
                    <Password autoComplete={ "current-password" }
                              errorMessage={ "Required" }
                              labelText={ "password" }
                              onChange={ setPassword }
                              type={ "password" }
                              value={ password }/>

                    <div className={ "login--submit-box" }>
                        <button
                            disabled={ !email || !password }
                            onClick={ () => {
                                setIsLoggingIn(true);
                                actions.login(email, password);
                            } }
                        >{ "Login" }</button>
                    </div>
                </form>
            </div>
            <div className={ `login--modal${ Boolean(error) ? "" : " is-hidden" }` }>
                <div className={ "login--modal-message" }>
                    <div>{ "Incorrect Email or password" }</div>
                    <button onClick={ () => {
                        setIsLoggingIn(false);
                        actions.clearLoginError();
                    } }>{ "OK" }</button>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = (state: Object): Object => ({ ...state.session });

const mapDispatchToProps = (dispatch): Object => ({
    actions: bindActionCreators({ ...sessionActionCreators, ...modalActionCreators }, dispatch)
});

export const LoginScreen = connect(mapStateToProps, mapDispatchToProps)(MyScreen);
